define('catalogsListView',[
  'module',
  'underscore',
  'app',
  'settings',
  'tableView',
  'tableDatetimeFieldView',
  'tableDynamicTextFieldView',
  'tableHeaderFieldView',
  'tableFieldView',
  'buttonView',
  'bootbox',
  'catalogEntities'
], function (
  Module,
  _,
  App,
  Settings,
  TableView,
  DatetimeFieldView,
  DynamicTextFieldView,
  HeaderFieldView,
  FieldView,
  ButtonView,
  bootbox
) {
  'use strict';

  var HeaderToolsView = HeaderFieldView.extend({
    className: 'catalogs-list-header-tools-view ' + HeaderFieldView.prototype.className,
    template: function(){ return '<div class="add-region"></div>'; },
    regions: { addRegion: '.add-region' },
    onRender: function(){
      var title = _.i18n('catalogs.createNew') || 'New catalog';
      var btn = new ButtonView({ type: 'add', color: 'orange', text: title, title: title });
      this.addRegion.show(btn);
      btn.on('click', _.bind(function(){
        require(['modalView', 'catalogsCreateView'], _.bind(function(ModalView, CreateView){
          ModalView.prototype.open({
            childView: CreateView,
            title: title,
            confirmButtonText: _.i18n('common.create') || 'Create',
            onConfirm: _.bind(function(model){
              App.request('catalog:create', model.toJSON())
              .done(_.bind(function(){
                this.tableView.reload();
                if (this.tableView.footerView && this.tableView.footerView.fetch) {
                  this.tableView.footerView.fetch();
                }
              }, this))
              .fail(function(xhr){
                // optional: basic alert on failure
                if (window && window.alert) {
                  var msg = (xhr && xhr.responseJSON && xhr.responseJSON.message) || 'Failed to create catalog';
                  window.alert(msg);
                }
              });
            }, this),
            model: App.request('catalog:model', {})
          });
        }, this));
      }, this));
    }
  });

  // Row tools: delete catalog
  var RowToolsView = FieldView.extend({
    className: 'catalogs-list-row-tools-view ' + FieldView.prototype.className,
    template: function(){ return '<div class="tools-region"></div>'; },
    regions: { toolsRegion: '.tools-region' },
    onRender: function(){
        var delBtn = new ButtonView({
          type: 'remove',
          text: _.i18n('common.delete'),
          color: 'red'
        });
        this.getRegion('toolsRegion').show(delBtn);
        delBtn.on('click', _.bind(function(){
          bootbox.confirm(_.i18n('common.confirmDelete') || 'Are you sure?', _.bind(function(result){
            if(!result) return;
            var secId = this.model.get('secId');
            App.request('catalog:delete', secId)
              .done(_.bind(function(){
                if (this.tableView) {
                  this.tableView.reload();
                  if (this.tableView.footerView && this.tableView.footerView.fetch) {
                    this.tableView.footerView.fetch();
                  }
                }
              }, this))
              .fail(function(xhr){
                if (window && window.alert) {
                  var msg = (xhr && xhr.responseJSON && xhr.responseJSON.message) || 'Failed to delete catalog';
                  window.alert(msg);
                }
              });
          }, this));
        }, this));
    }
  });

  Module.exports = TableView.extend({
    className: 'catalogs-list-view ' + TableView.prototype.className,
    pageSize: 50,
    pageMode: 'pagination',

    setFields: function(){
      var fields = [];

      fields.push({
        name: 'Name',
        label: _.i18n('common.name'),
        className: 'name',
        view: DynamicTextFieldView,
        value: 'name',
        bind: 'name'
      });

      fields.push({
        name: 'Tools',
        className: 'tools',
        view: RowToolsView,
        headerView: HeaderToolsView
      });

      return fields;
    },

    fetch: function(first, pageSize){
      var defer = $.Deferred();
      App.request('catalogs:list').done(_.bind(function(models){
        // No server-side paging provided; emulate
        var slice = models.slice(first, first + pageSize);
        defer.resolve(slice);
      }, this));
      return defer.promise();
    },

    fetchCount: function(){
      var defer = $.Deferred();
      App.request('catalogs:list').done(function(models){
        defer.resolve(models.length || 0);
      });
      return defer.promise();
    },

    onRowDoubleClick: function(view){
      require(['catalogsDetailView'], function(DetailView){
        DetailView.prototype.open(view.model.get('secId'));
      });
    }
  });
});

